// src/locales/si/header.js
export const header = {
    searchPlaceholder: "ඇණවුම්, නිෂ්පාදන, ගනුදෙනුකරුවන් සොයන්න...",
    search: "සොයන්න",
    notifications: "දැනුම්දීම්",
    markAllRead: "සියල්ල කියවූ ලෙස සලකුණු කරන්න",
    viewAllNotifications: "සියලුම දැනුම්දීම් බලන්න",
    noNotifications: "දැනුම්දීම් නැත",
    profileSettings: "පැතිකඩ සැකසීම්",
    accountSettings: "ගිණුම් සැකසීම්",
    businessSettings: "ව්‍යාපාර සැකසීම්",
    roleManagement: "භූමිකා කළමනාකරණය",
    areYouSureLogout: "ඔබට ඇත්තටම ඉවත් වීමට අවශ්‍යද?",
    searchResults: "සෙවුම් ප්‍රතිඵල",
    searching: "සොයමින්...",
    searchError: "ඇණවුම් සෙවීම අසාර්ථක විය",
    noOrdersFound: "ඇණවුම් හමු නොවිණි",
    searchHint: "ඇණවුම් අංකය, දුරකථන අංකය, හෝ ගුවන් බිල් අංකය මගින් සොයන්න",
    viewAllResults: "සියලුම ප්‍රතිඵල බලන්න",
    mobileSearchHint: "ඇණවුම් අංකය, දුරකථන අංකය, හෝ ගුවන් බිල් අංකය ඇතුළත් කරන්න. ප්‍රතිඵල බැලීමට enter ඔබන්න."
}